<motif-modal-title>
  <h3 class="motif-body1-default-regular m-0">Replicate via Transition</h3>
  <button type="button" class="modal-close-btn" aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon class="motif-modal-header-close-icon" var='--navigation-Ic-Close-48px' aria-hidden="true"></motif-icon>
  </button>
</motif-modal-title>

<motif-modal-content>
  <div class="right-slide-model-wrapper">
    <!-- Country -->
    <div class="field">
      <motif-form-field class="w-100">
        <label motifLabel>Country</label>
        <motif-select
          labelPosition="inside"
          aria-label="Select Country"
          [(ngModel)]="selectedCountry"
          placeholder="Select Country"
          (selectionChange)="onSelectCountry($event)"
          validationInteraction="touched"
          aria-required="true"
          [required]="true">
          <motif-option *ngFor="let country of countries" [value]="country">
            {{ country.countryName }}
          </motif-option>
        </motif-select>
      </motif-form-field>
    </div>

    <!-- Entity -->
    <div class="field">
      <motif-form-field class="w-100">
        <label motifLabel>Entity</label>
        <motif-select
          labelPosition="inside"
          aria-label="Select Entity"
          [(ngModel)]="selectedEntity"
          placeholder="Select Entity"
          (selectionChange)="onSelectEntity($event)"
          validationInteraction="touched"
          [disabled]="!selectedCountry"
          aria-required="true"
          [required]="true">
          <motif-option *ngFor="let entity of filteredEntities" [value]="entity">
            {{ entity.entityCode }}
          </motif-option>
        </motif-select>
      </motif-form-field>
    </div>

    <!-- Year -->
    <div class="field">
      <motif-form-field class="w-100">
        <label motifLabel>Year</label>
        <motif-select
          labelPosition="inside"
          aria-label="Select Year"
          [(ngModel)]="selectedYear"
          placeholder="Select Year"
          validationInteraction="touched"
          aria-required="true"
          [required]="true">
          <motif-option *ngFor="let year of years" [value]="year">
            {{ year.auditYear }}
          </motif-option>
        </motif-select>
      </motif-form-field>
    </div>

    <!-- Period -->
    <div class="field">
      <motif-form-field class="w-100">
        <label motifLabel>Period</label>
        <motif-select
          labelPosition="inside"
          aria-label="Select Period"
          [(ngModel)]="selectedPeriod"
          placeholder="Select Period"
          [sortComparator]="periodSortComparator"
          validationInteraction="touched"
          aria-required="true"
          [required]="true">
          <motif-option *ngFor="let period of periods" [value]="period">
            {{ period.periodName }}
          </motif-option>
        </motif-select>
      </motif-form-field>
    </div>

    <!-- Frequency -->
    <div class="field">
      <motif-form-field class="w-100">
        <label motifLabel>Frequency</label>
        <motif-select
          labelPosition="inside"
          aria-label="Select Frequency"
          [(ngModel)]="selectedFrequency"
          placeholder="Select Frequency"
          validationInteraction="touched"
          aria-required="true"
          [required]="true">
          <motif-option *ngFor="let freq of frequencies" [value]="freq">
            {{ freq }}
          </motif-option>
        </motif-select>
      </motif-form-field>
    </div>

    <!-- Filing Start Date -->
    <div class="field">
      <motif-form-field class="w-100" [ngClass]="{ 'motif-form-field-error': startDateTouched && !filingStartDate }">
        <label motifLabel>Filing Start Date</label>
        <input
          motifInput
          [motifDatePicker]="dateStart"
          [motifDatePickerTrigger]="dateStart"
          selectMode="single"
          labelPosition="inside"
          [required]="true"
          [readonly]="true"
          [ngClass]="{ 'is-invalid': !filingStartDate }"
          (dateTimeChange)="onStartDateChange($event)"
          (clear)="onClearStartDate()"
          aria-label="Filing Start Date"
        />
        <motif-date-picker #dateStart></motif-date-picker>
      </motif-form-field>
    </div>

    <!-- Filing End Date -->
    <div class="field">
      <motif-form-field class="w-100" [ngClass]="{ 'motif-form-field-error': endDateTouched && !filingEndDate }">
        <label motifLabel>Filing End Date</label>
        <input
          motifInput
          [motifDatePicker]="dateEnd"
          [motifDatePickerTrigger]="dateEnd"
          selectMode="single"
          labelPosition="inside"
          [required]="true"
          [readonly]="true"
          [ngClass]="{ 'is-invalid': !filingEndDate }"
          (dateTimeChange)="onEndDateChange($event)"
          (clear)="onClearEndDate()"
          aria-label="Filing End Date"
        />
        <motif-date-picker #dateEnd></motif-date-picker>
      </motif-form-field>
    </div>

    <!-- Stat Due Date -->
    <div class="field">
      <motif-form-field class="w-100" [ngClass]="{ 'motif-form-field-error': statDueDateTouched && !statutoryDueDate }">
        <label motifLabel>Stat Due Date</label>
        <input
          motifInput
          [motifDatePicker]="dateStatDue"
          [motifDatePickerTrigger]="dateStatDue"
          selectMode="single"
          labelPosition="inside"
          [required]="true"
          [readonly]="true"
          [ngClass]="{ 'is-invalid': !statutoryDueDate }"
          (dateTimeChange)="onStatDueDateChange($event)"
          (clear)="onClearStatDueDate()"
          aria-label="Statutory Due Date"
        />
        <motif-date-picker #dateStatDue></motif-date-picker>
      </motif-form-field>
    </div>

    <!-- Mapping Template ID -->
    <div class="field">
        <motif-form-field class="w-100">
          <label motifLabel>Mapping Template ID</label>
          <input motifInput labelPosition="inside" type="text" [(ngModel)]="mappingTemplateId" 
          placeholder="Enter Mapping Template ID" aria-required="true" [required]="true" />
        </motif-form-field>
      </div>

    <!-- Obligation ID -->
  
       <div class="field">
        <motif-form-field class="w-100">
          <label motifLabel>Obligation ID</label>
          <input motifInput labelPosition="inside" type="text" [(ngModel)]="obligationId" 
          placeholder="Enter Obligation ID" aria-required="true" [required]="true" />
        </motif-form-field>
      </div>
  </div>
</motif-modal-content>

<motif-modal-actions>
  <button motifButton motif-modal-close color="secondary" aria-label="Cancel" role="button">
    Cancel
  </button>
  
  <button motifButton color="primary" aria-label="Replicate"
    (click)="onReplicate()"
    [disabled]="isReplicateDisabled"
    role="button">
    {{ isSubmitting ? 'Replicating...' : 'Replicate' }}
  </button>
</motif-modal-actions>
